import type { TutorTaskUpdatePayload } from '../../model/tutor-tasks/types'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TutorTaskUpdateApiOptions {
  taskId: number
  payload: TutorTaskUpdatePayload
  successMessage: string
  onStart?: () => void
  onFinish?: () => void
}

/** `PATCH /admin-api/tutor-tasks/{task}` — partial; cancel is just `{status: 'CANCELED'}`. */
export const useTutorTaskUpdateApi = async (options: TutorTaskUpdateApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.tutor-task.update', { task_id: options.taskId })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.patch<ApiResponse>(url, options.payload)
    toast.success(options.successMessage)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    options.onFinish?.()
  }
}
